export default function CareersHero() {
  return (
    <section className="relative bg-white pt-32 pb-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-600 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <i className="ri-briefcase-line"></i>
            <span>Join Our Team</span>
          </div>
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            Build Your Career with TrackVerse
          </h1>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Join a team of passionate professionals revolutionizing global logistics. We're looking for talented individuals who want to make an impact in the world of international shipping and supply chain innovation.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a 
              href="#positions" 
              className="bg-blue-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              View Open Positions
            </a>
            <a 
              href="#culture" 
              className="bg-white text-blue-600 px-8 py-3 rounded-lg font-medium border-2 border-blue-600 hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              Learn About Our Culture
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-4xl font-bold text-blue-600 mb-2">50+</div>
            <div className="text-gray-600 text-sm">Countries</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-green-600 mb-2">5,000+</div>
            <div className="text-gray-600 text-sm">Team Members</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-blue-600 mb-2">150+</div>
            <div className="text-gray-600 text-sm">Locations</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-green-600 mb-2">40+</div>
            <div className="text-gray-600 text-sm">Open Roles</div>
          </div>
        </div>
      </div>
    </section>
  );
}
